import React from "react";
import axios from "axios";

export default function HomeLoader() {
}